module.exports = __webpack_public_path__ + "components/icon/static/sunrise-db56a49633b1f5891d8149188e7359de.svg";